import React from "react";
import {Button} from '@material-ui/core';
import {Row, Col} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';

import {Summaries} from "../../modules/DashboardContents/Summaries";
import {SummaryTable} from "../../modules/DashboardContents/SummaryTable";
import {CardBody, Card} from "../../../../_metronic/_partials/controls";
import {count} from "../../../../utils/formatter";

export function DashboardContainer() {
  const history = useHistory();

  return (
    <Row>
      <Col sm={12} className="d-flex">
        <Card className="flex-grow-1">
          <CardBody>
            <Summaries
              summaries={[
                {key: 'week', label: '이번주 주문건수', value: count(0)},
                {key: 'today', label: '오늘 주문건수', value: count(0)},
                {key: 'dalay', label: '배송지연', value: count(0)},
                {key: 'cs', label: 'CS 답변 대기건수', value: count(0)},
                {key: 'sale', label: '이번달 판매금액', value: count(0)},
              ]}
            />
          </CardBody>
        </Card>
      </Col>

      <Col sm={6} className="d-flex">
        <Card className="flex-grow-1">
          <CardBody>
            <SummaryTable
              header={`신규 등록 상품`}
              moreButton={
                <Button
                  color="primary"
                  size="large"
                  onClick={() => history.push('/sales/orders')}
                >
                  룰루 상품 이동 >
                </Button>
              }
              columns={[
                {key: 'no', label: 'NO'},
                {key: 'goodsNm', label: '상품명'},
                {key: 'ordAmt', label: '공급가'},
                {key: 'ordDtime', label: '상품 등록일'},
              ]}
              rows={[]}
            />
          </CardBody>
        </Card>
      </Col>

      <Col sm={6} className="d-flex">
        <Card className="flex-grow-1">
          <CardBody>
            <SummaryTable
              header={`최근 주문 내역`}
              moreButton={
                <Button
                  color="primary"
                  size="large"
                  onClick={() => history.push('/sales/orders')}
                >
                  주문 관리 이동 >
                </Button>
              }
              columns={[
                {key: 'no', label: 'NO'},
                {key: 'goodsNm', label: '주문상품'},
                {key: 'ordQty', label: '구매 수량'},
                {key: 'ordAmt', label: '결제금액'},
                {key: 'ordDtime', label: '주문 일시'},
              ]}
              rows={[]}
            />
          </CardBody>
        </Card>
      </Col>

      <Col sm={6} className="d-flex">
        <Card className="flex-grow-1">
          <CardBody>
            <SummaryTable
              header={`배송 지연 목록`}
              columns={[
                {key: 'no', label: 'NO'},
                {key: 'custNm', label: '주문자'},
                {key: 'goodsNm', label: '주문 상품'},
                {key: 'ordDTime', label: '주문 일시'},
                {key: 'delayDate', label: '지연일'},
              ]}
              rows={[]}
            />
          </CardBody>
        </Card>
      </Col>

      <Col sm={6} className="d-flex">
        <Card className="flex-grow-1">
          <CardBody>
            <SummaryTable
              header={`CS 현황`}
              moreButton={
                <Button
                  color="primary"
                  size="large"
                  onClick={() => history.push('/cs/qna')}
                >
                  CS 목록 이동 >
                </Button>
              }
              columns={[
                {key: 'no', label: 'NO'},
                {key: 'custNm', label: '주문자명'},
                {key: 'title', label: '문의 제목'},
                {key: 'qnaDate', label: '문의 일시'},
                {key: 'ordDate', label: '주문 일시'}
              ]}
              rows={[]}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
